import { Box, Button, Card, CardContent, CardHeader, Typography } from '@mui/material';
import { FC } from 'react';
import { COLORS } from '../../../../services/constants/colors';
import { TVATReportCardProps } from './types';

export const VATReportCard: FC<TVATReportCardProps> = ({
	title,
	downloadHandler,
	startDownload,
	downloadHandlerWithPayment = null,
}) => {
	return (
		<Box
			sx={{
				width: '100%',
				p: 1,
			}}
		>
			<Typography variant="h6" sx={{ color: COLORS.PRIMARY, fontWeight: '550', fontSize: '1.1rem' }}>
				{title}
			</Typography>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'start',
					gap: 1,
					width: '100%',
					mt: 1,
				}}
			>
				<Button
					variant="contained"
					onClick={downloadHandler}
					sx={{
						textTransform: 'none',
						height: '24px',
						p: '4px 10px',
						border: `0.5px solid ${COLORS.PRIMARY}!important`,
						fontSize: '0.8rem',
						width: '100%',
					}}
					size="small"
				>
					Paid
				</Button>
				{downloadHandlerWithPayment && (
					<Button
						variant="contained"
						onClick={downloadHandlerWithPayment}
						sx={{
							textTransform: 'none',
							height: '24px',
							p: '4px 10px',
							border: `0.5px solid ${COLORS.PRIMARY}!important`,
							fontSize: '0.8rem',
							width: '100%',
						}}
						size="small"
					>
						Not Paid
					</Button>
				)}
			</Box>
		</Box>
	);
};
